module.exports = __webpack_public_path__ + "static/Home3_Hover-c602702c697ad83ba8d9351273765fab.png";